const actions = {
    SET_DATA: 'workspace_users/SET_DATA',
    GET_DATA: 'workspace_users/GET_DATA',
};

export default actions
